import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { useDebouncedCallback } from '@fabric-app/hooks/useDebouncedCallback';
import React__default from 'react';

const useIntersectionObserver = ({ defaultInView = false, root, target, onIntersect, threshold = 1e-3, rootMargin = "400px", enabled = true, debounceDelay = 100, rootEl, recalculateKey }) => {
  const onIntersectDebounced = useDebouncedCallback(onIntersect, debounceDelay);
  const [isInView, setIsInView] = React__default.useState(defaultInView);
  useClientLayoutEffect(() => {
    const el = target instanceof HTMLElement ? target : target?.current;
    if (!el || !enabled) {
      return;
    }
    const radixViewportEl = el.closest("[data-radix-scroll-area-viewport]") || null;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          onIntersectDebounced?.();
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      });
    }, {
      root: root?.current || rootEl || radixViewportEl || document,
      rootMargin,
      threshold
    });
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [
    target,
    root,
    enabled,
    onIntersect,
    rootMargin,
    threshold,
    rootEl,
    recalculateKey
  ]);
  return isInView;
};

export { useIntersectionObserver };
//# sourceMappingURL=useIntersectionObserver.js.map
